/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Error_Name_MaxInputs */

const vi_customer_error_name_max = /** @type {(inputs: Customer_Error_Name_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên khách hàng tối đa 255 ký tự`)
};

/**

* @param {Customer_Error_Name_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_error_name_max = /** @type {((inputs?: Customer_Error_Name_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Error_Name_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_error_name_max(inputs)
});